import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let resource_id = useDataValue({
    context: 'preview_document',
    path: 'document_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      resource_id,
    },
    pause: !resource_id,
    requestPolicy: 'network-only',
  }
}
